import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";
import get from "lodash/get";
import ProductPriceForm from "../ProductPriceForm";
import ProductNewPriceForm from "../ProductNewPriceForm";
import ProductForm from "../ProductForm";
import { PRODUCT_ORDER_INTENT } from "utils/constants/pricing";
import { STATE_KEYS } from "utils/constants/state";
import { getProductVariableContext } from "utils/variables";
import { useProductsPrices } from "utils/selectors";

const ProductShow = ({ name, schema }) => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const scrollRef = useRef(null);
  const scrollTop = () => {
    scrollRef.current && scrollRef.current.scrollTo(0, 0);
  };
  const productsPath = `${name}.data.products`;
  const products = get(values, productsPath, []);

  const productOrderIntent = get(
    values,
    STATE_KEYS.EDITOR.PRODUCT_ORDER_INTENT
  );

  const activeProductUID = get(
    values,
    STATE_KEYS.EDITOR.PRICING_ACTIVE_PRODUCT
  );
  const activeProductIndex = products.findIndex(
    ({ uid }) => uid === activeProductUID
  );
  const activeProduct = products[activeProductIndex];
  const pricePrimaries = get(values, STATE_KEYS.MANIFEST.PRICING_PRIMARIES);
  const { prices } = useProductsPrices();

  const activePriceUID = get(values, STATE_KEYS.EDITOR.PRICING_ACTIVE_PRICE);
  const activePrice = prices.find((price) => price.id === activePriceUID);

  let content = null;
  const showNewPriceForm =
    activeProduct && productOrderIntent === PRODUCT_ORDER_INTENT.PRICE_ADD;
  const showProductPrice = activePrice && activeProduct;
  const showProduct = Boolean(activeProduct);

  const variableContext = getProductVariableContext(
    activeProduct,
    pricePrimaries
  );

  const showProductPriceForm = Boolean(showProductPrice && activePrice);

  useEffect(() => {
    scrollTop();
  }, [productOrderIntent, activeProductUID, activePriceUID]);

  if (showNewPriceForm) {
    content = (
      <ProductNewPriceForm
        name={name}
        scrollTop={scrollTop}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
        product={activeProduct}
        productIndex={activeProductIndex}
        pricePrimaries={pricePrimaries}
      />
    );
  } else if (showProductPriceForm) {
    content = (
      <ProductPriceForm
        name={name}
        scrollTop={scrollTop}
        pricePrimaries={pricePrimaries}
        product={activeProduct}
        price={activePrice}
        setFieldValue={setFieldValue}
        setFieldTouched={setFieldTouched}
      />
    );
  } else if (showProduct) {
    content = (
      <ProductForm
        scrollTop={scrollTop}
        name={name}
        product={activeProduct}
        productIndex={activeProductIndex}
        variableContext={variableContext}
        pricePrimaries={pricePrimaries}
        schema={schema}
      />
    );
  } else {
    content = (
      <div className="f5">{`No product for product ${activeProductUID}`}</div>
    );
  }

  return (
    <div
      ref={scrollRef}
      className="scrollableMenu w-100 overflow-y-scroll-ns h-100 relative bg-white bh--inset"
    >
      {content}
    </div>
  );
};

ProductShow.propTypes = {
  uid: PropTypes.string.isRequired,
  uuid: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  schema: PropTypes.object.isRequired
};

export default ProductShow;
